import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconTipVideo = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      ref={ref}
      width="22"
      height="26"
      viewBox="0 0 22 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="yfm-icon yfm-icon-tip-video"
      {...omit(props, ["className"])}
    >
      <path
        d="M14.1429 0H2.376C1.06857 0 0 1.06857 0 2.376V22.7669C0 24.0869 1.06857 25.1429 2.376 25.1429H19.624C20.9314 25.1429 22 24.0743 22 22.7669V7.31657L14.1429 0ZM14.3189 2.32571L19.888 7.50514H16.2926C15.2114 7.50514 14.3314 6.62514 14.3189 5.544V2.32571ZM20.4286 22.7669C20.4286 23.2069 20.064 23.5714 19.624 23.5714H2.376C1.936 23.5714 1.57143 23.2069 1.57143 22.7669V2.376C1.57143 1.936 1.936 1.57143 2.376 1.57143L12.76 1.584V5.544C12.76 7.49257 14.344 9.07657 16.2926 9.07657H20.4286V22.7669Z"
        fill="#17215C"
      />
      <path
        d="M13.7532 15.0732L13.9543 14.872C14.1555 14.4697 14.1555 14.0674 13.7532 13.8663L9.94404 11.264C9.94404 11.264 9.7429 11.0629 9.54175 11.0629C9.13947 11.0629 8.73718 11.4652 8.73718 11.8674V16.8709C8.73718 17.072 8.73718 17.2732 8.93833 17.2732C9.13947 17.6754 9.7429 17.6754 10.1452 17.4743L13.7532 15.0732Z"
        fill="#17215C"
      />
    </svg>
  )
);

IconTipVideo.displayName = "IconTipVideo";

export default IconTipVideo;
